import { render } from "./InstagramModal.vue?vue&type=template&id=4eae1e93&scoped=true"
import script from "./InstagramModal.vue?vue&type=script&lang=js"
export * from "./InstagramModal.vue?vue&type=script&lang=js"

import "./InstagramModal.vue?vue&type=style&index=0&id=4eae1e93&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4eae1e93"

export default script